export default __webpack_public_path__ + "static/media/paris.5ea39f78.jpg";